import { PageCalculatorService } from '@app/base/service/page-calculator.service';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ChangeOrganismoService } from './service/change-organismo.service';
import { ChangeOrganismoComponent } from './component/change-organismo.component';
import { ModalComponentModule } from '@app/base/component/modal.component.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedEclesialComponentModule } from '@app/base/module/shared.eclesial.component.module';
import { AgGridModule } from 'ag-grid-angular';
import { ErrorHandlerService } from '@app/base/service/error-handler.service';

@NgModule({
	imports: [
		SharedEclesialComponentModule,
		ModalComponentModule,
		ReactiveFormsModule,
		CommonModule,
		AgGridModule.withComponents([]),
	],
	declarations: [
		ChangeOrganismoComponent,
	],
	exports: [
		ChangeOrganismoComponent,
		SharedEclesialComponentModule,
	],
	providers: [
        ChangeOrganismoService,
		PageCalculatorService,
		ErrorHandlerService,
	],
	entryComponents: [
	],
})
export class ChangeOrganismoModule { }
